import {
  defineNuxtPlugin,
  addRouteMiddleware,
  useState,
  useRuntimeConfig,
  useCookie
} from "#app";
import { ofetch } from "ofetch";
export default defineNuxtPlugin(async () => {
  const auth = useState("auth", () => {
    return {
      user: null,
      loggedIn: false,
      token: null
    };
  });
  const config = useRuntimeConfig().nuxtSanctumAuth;
  addRouteMiddleware("fetch-user", async () => {
    getToken();
    await getUser();
  }, { global: true });
  addRouteMiddleware("auth", async () => {
    if (auth.value.loggedIn === false) {
      return config.redirects.login;
    }
  });
  addRouteMiddleware("guest", async () => {
    if (auth.value.loggedIn) {
      return config.redirects.home;
    }
  });
  const apiFetch = (endpoint, options) => {
    const fetch = ofetch.create({
      baseURL: config.baseUrl,
      credentials: "include",
      headers: {
        Accept: "application/json",
        [config.csrf.headerKey]: !config.token ? useCookie(config.csrf.cookieKey).value : null,
        "Authorization": config.token ? "Bearer " + auth.value.token : null
      }
    });
    return fetch(endpoint, options);
  };
  async function csrf() {
    await ofetch(config.endpoints.csrf, {
      baseURL: config.baseUrl,
      credentials: "include",
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    });
  }
  const getToken = () => {
    auth.value.token = useCookie("nuxt-sanctum-auth-token").value;
  };
  const setToken = (token) => {
    useCookie("nuxt-sanctum-auth-token").value = token;
  };
  const clearToken = () => {
    useCookie("nuxt-sanctum-auth-token").value = null;
  };
  async function getUser() {
    if (auth.value.loggedIn && auth.value.user) {
      return auth.value.user;
    }
    try {
      const user = await apiFetch(config.endpoints.user);
      if (user) {
        auth.value.loggedIn = true;
        auth.value.user = user;
        return user;
      }
    } catch (error) {
    }
  }
  async function login(data, callback) {
    if (!config.token) {
      await csrf();
    }
    try {
      const response = await apiFetch(config.endpoints.login, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          Accept: "application/json",
          [config.csrf.headerKey]: !config.token ? useCookie(config.csrf.cookieKey).value : null,
          "Authorization": config.token ? "Bearer " + auth.value.token : null
        }
      });
      if (config.token && response) {
        setToken(response.token);
      }
      if (callback !== void 0) {
        callback(response);
        return;
      }
      window.location.replace(config.redirects.home);
    } catch (error) {
      throw error.data;
    }
  }
  const logout = async (callback) => {
    try {
      const response = await apiFetch(config.endpoints.logout, {
        method: "POST"
      });
      if (callback !== void 0) {
        callback(response);
        return;
      }
      window.location.replace(config.redirects.logout);
    } catch (error) {
      console.log(error);
    } finally {
      auth.value.loggedIn = false;
      auth.value.user = null;
      auth.value.token = null;
      clearToken();
    }
  };
  return {
    provide: {
      apiFetch,
      csrf,
      sanctumAuth: {
        login,
        getUser,
        logout
      }
    }
  };
});
